'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = {
  button: 'Aksepter',
  notice: 'Hallo! V\xE5r nettside bruker informasjonskapsler for \xE5 hjelpe oss med \xE5 gi deg den\n    beste brukeropplevelsen og \xE5 levere tilpassede opplevelser. Du kan finne ut mer om\n    informasjonskapsler vi bruker og dine valg for informasjonskapsel,\n    <a href="https://pod-point.no/personvernserkl%C3%A6ring" target="_blank">her</a>.\n    Hvis du fortsetter \xE5 bruke tjenestene v\xE5re, antar vi at du er ok med dette.'
};
module.exports = exports['default'];